// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"6fb9afdcf39c9130","7229":"ef905d2196dd9daa","8681":"fe2101b4e8bcc25d"}[chunkId] + ".js";
};